import { useState, useEffect } from "react";

// utils
import axios from "../../../utils/axios";
// hooks
import useAuth from "../../../hooks/useAuth";

import PropTypes from "prop-types";
// @mui
import { styled } from "@mui/material/styles";
import { Box, Link, Typography } from "@mui/material";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { role } = useAuth();

  const [user, setUser] = useState({});

  const getProfile = async () => {
    axios
      .post("/auth/profile")
      .then((res) => {
        const user = res.data.user;
        setUser(user);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if ( role !== "GUEST" ) {
      getProfile();
    }
  }, []);

  return (
    <Link underline="none" color="inherit">
      { role !== "GUEST" && (
        <RootStyle
          sx={{
            ...(isCollapse && {
              bgcolor: "transparent",
            }),
          }}
        >
          <Box
            sx={{
              transition: (theme) =>
                theme.transitions.create("width", {
                  duration: theme.transitions.duration.shorter,
                }),
              ...(isCollapse && {
                ml: 0,
                width: 0,
              }),
            }}
          >
            <Typography variant="menuUserName">
              {`${user.name} ${user.surname}`}
            </Typography>
          </Box>
        </RootStyle>
      )}
    </Link>
  );
}
